import User from 'model/User';
import Data from 'model/Data';

import ZoneList from 'model/ZoneList';
import PondList from 'model/PondList';
import VisitList from 'model/VisitList';
import ImageList from 'model/ImageList';

import Network from 'model/Network';
import Geolocation from 'model/Geolocation';
import Settings from 'model/Settings';


export default {
	user: User,
	data: Data,

	pond_list: PondList,
	zone_list: ZoneList,
	visit_list: VisitList,
	image_list: ImageList,

	network: Network,
	geolocation: Geolocation,
	settings: Settings
};
